import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../styles/WhoWeAreSection.scss";
import img1 from "../assets/pool_th.jpg";
import img2 from "../assets/house_th.jpg";
import img3 from "../assets/project_th.jpg";
import img4 from "../assets/house_th_p1.jpg";
import img5 from "../assets/house_th_p2.jpg";
import img6 from "../assets/tunelthing_ph.jpg";
import Logo from "../assets/logo.png";

export default function WhoWeAreSection() {
  const sectionRef = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="who-we-are-section py-5" ref={sectionRef}>
      <Container>
        {/* HERO ROW */}
        <Row className="align-items-center mb-5">
          <Col lg={4} className="p-0">
            <img
              src={img4}
              alt="Broilo Aquecimento"
              className={`img2 slide-up ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0s" }}
            />
          </Col>
          <Col lg={4}>
            <h2
              className={`pop-in ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0.2s" }}
            >
              Quem somos
            </h2>
            <p
              className={`pop-in lead ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0.4s" }}
            >
              Nossa missão é levar ao cliente sistemas de aquecimento
              confiáveis, duradouros e adaptados às necessidades específicas de
              cada projeto, seja residencial, comercial ou industrial.
              Valorizamos a transparência, a qualidade dos materiais e o
              atendimento personalizado para construir parcerias duradouras.
            </p>
          </Col>
          <Col lg={4} className="p-0">
            <img
              src={img5}
              alt="Broilo Aquecimento"
              className={`img3 slide-up ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0s" }}
            />
          </Col>
        </Row>

        {/* TEXT + TEAM PHOTO ROW */}
        <Row className="align-items-center mb-4">
          <Col lg={6} className="p-0">
            <img
              src={img3}
              alt="Time Broilo"
              className={`img0 slide-up ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0.6s" }}
            />

            <img
              src={img6}
              alt="Time Broilo"
              className={`img1 slide-up ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0.6s" }}
            />
            <img
              src={img1}
              alt="Time Broilo"
              className={`img11 slide-up ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0.6s" }}
            />
          </Col>
          <Col lg={6}>
            {[
              <>
                A ThermalHydro nasceu do sonho de criar soluções de aquecimento
                que aliam tecnologia, eficiência e sustentabilidade. Fundada por
                especialistas do setor térmico, a empresa surgiu para atender a
                uma demanda crescente por sistemas modernos que oferecessem
                conforto e economia, sem abrir mão do cuidado com o meio
                ambiente.
              </>,
              <>
                Desde o início, investimos em pesquisa e desenvolvimento,
                buscando as melhores tecnologias nacionais e internacionais para
                trazer ao mercado produtos inovadores e de alta performance.
                Contamos também com assistência técnica autorizada das marcas{" "}
                <strong>Texius</strong> e <strong>Komeco</strong>, garantindo
                segurança, confiabilidade e suporte especializado aos nossos
                clientes. Com dedicação e foco na qualidade, conquistamos a
                confiança de clientes e parceiros, expandindo nossa atuação para
                diversos segmentos, como residências, comércio, indústria e
                lazer.
              </>,
              <>
                Ao longo dos anos, a ThermalHydro consolidou-se como referência
                no setor, sempre acompanhando as tendências e antecipando
                soluções que respondem às necessidades atuais e futuras. Nossa
                história é construída diariamente com trabalho, ética e o
                compromisso de transformar ambientes por meio do aquecimento
                sustentável.
              </>,
            ].map((para, i) => (
              <p
                key={i}
                className={`pop-in ${visible ? "visible" : ""}`}
                style={{ transitionDelay: `${0.8 + i * 0.2}s` }}
              >
                {para}
              </p>
            ))}
          </Col>
        </Row>

        {/* CALL TO ACTION */}
        <div className="text-center mt-4">
          <a
            href="https://wa.me/555391425203"
            target="_blank"
            style={{ color: "inherit" }}
          >
            <Button
              variant="primary"
              size="lg"
              className={`pop-in ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "1.4s" }}
            >
              Entre em contato
            </Button>
          </a>
        </div>
      </Container>
    </section>
  );
}
